import React from 'react';
import { Shield, Award, Clock, Users } from 'lucide-react';

const TrustSignals = () => {
  const signals = [
    {
      icon: Shield,
      title: "Elite Manufacturer Certifications",
      description: "$2M Liability Coverage • Fully Insured"
    },
    {
      icon: Award,
      title: "Award-Winning Service",
      description: "BBB A+ Rating • Angie's List Super Service Award"
    },
    {
      icon: Clock,
      title: "24/7 Emergency Response",
      description: "Storm damage? We respond within 2 hours"
    },
    {
      icon: Users,
      title: "5000+ Happy Customers",
      description: "15+ years serving Eastern NC families"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-brand-charcoal-gray mb-4">
            Why 5000+ Homeowners Trust Carolina Trophy Roofs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're not just another roofing company. We're your neighbors, committed to protecting your most valuable investment.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {signals.map((signal, index) => (
            <div key={index} className="text-center group">
              <div className="bg-gradient-to-br from-brand-carolina-blue to-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-200">
                <signal.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-brand-charcoal-gray mb-2">
                {signal.title}
              </h3>
              <p className="text-sm text-gray-600">
                {signal.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Social Proof Banner */}
        <div className="mt-12 bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-xl p-6 text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center">
              <div className="flex -space-x-2">
                {[1,2,3,4,5].map((i) => (
                  <div key={i} className="w-10 h-10 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full border-2 border-white flex items-center justify-center">
                    <span className="text-white text-xs font-bold">{i}</span>
                  </div>
                ))}
              </div>
              <span className="ml-3 text-sm font-medium text-gray-700">
                200+ Recent Reviews
              </span>
            </div>
            <div className="text-center sm:text-left">
              <div className="text-2xl font-bold text-green-600">4.9/5 ⭐</div>
              <div className="text-sm text-gray-600">Average Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;